import lookers from 'collections/lookers';
import { observer } from 'mobx-react-lite';
import { LookerPage } from 'pages';
import React from 'react';
import { Route } from 'react-router-dom';
import { routes } from 'routes';

const LogisticsController = observer(() => (
  <>
    <Route
      path={routes.lookers.logistics.warehousePath()}
      exact
      render={(props) => <LookerPage {...props} url={lookers.logistics.warehouse} title="ERP | Warehouse" />}
    />

    <Route
      path={routes.lookers.logistics.analytics.logisticsAutomationPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Logistics Automation | Logistics | ERP"
          url={lookers.logistics.analytics.logisticsAutomation}
        />
      )}
    />
  </>
));

export default LogisticsController;
